import { Sparkles } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useVersion } from "@/hooks/use-version";

export function ReleaseNotesPage() {
  const { data } = useVersion();

  return (
    <div className="mx-auto max-w-4xl space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-foreground">Release Notes</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Recent changes and updates to Prominent Builders OS.
        </p>
      </div>
      <Card>
        <CardHeader className="flex flex-row items-center gap-3">
          <Sparkles className="h-5 w-5 text-muted-foreground" />
          <CardTitle>Current version {data?.version ? `· ${data.version}` : ""}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3 text-sm text-muted-foreground">
          <p>
            Release notes will appear here. A detailed changelog is coming soon — until then, please
            see recent commits or reach out to your administrator.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
